import { StackingToastsData } from "../../../../Data/BonusUi/Toasts";
import CommonToast from "../Common/CommonToast";

const StackingToastsLists = () => {
  return (
    <>
      {StackingToastsData.map((data) => (
        <CommonToast key={data.id} icon={data.icon} strongText={data.strongText} smallClass="txt-muted" smallText={data.smallText} bodyText={data.bodyText} />
      ))}
    </>
  );
};
export default StackingToastsLists;
